export const TagType = {
  Include: 'include',
  Exclude: 'exclude'
} as const;

export type TagTypeType = (typeof TagType)[keyof typeof TagType];

export interface CourseTagWithTranslation {
  value: string;
  translationKey: string;
}

export interface SelectedTag {
  name: string;
  type: TagTypeType;
}
